export default {
    RECEIVE_BOAT_CATEGORY: 'boat.category.received',
    RECEIVE_ONE_BOAT_CATEGORY: 'boat.category.received_one',
};
